import {UPDATE_GLOBAL_SETTINGS_SUCCESS} from 'redux/actionType'

export const updateGlobalSettings = (data) => {
  return (dispatch) => {
    dispatch({type: UPDATE_GLOBAL_SETTINGS_SUCCESS, data: data})
  }
}
